import { getKeycloakInstance } from "@/contexts/AuthProvider";
import { getEnv } from "@/utils/runtime-config";
import Axios from "axios";
import type Keycloak from "keycloak-js";
import { getCookie } from "./cookie";

const axios = Axios.create({
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
});

axios.interceptors.request.use(async (config) => {
  const url = config.url || "";
  const isBroadcasting = url.includes("/broadcasting");

  // Set baseURL only if not already set
  if (!config.baseURL) {
    // For broadcasting endpoints, use backend URL without /api prefix
    config.baseURL = isBroadcasting
      ? getEnv("VITE_BACKEND_URL")
      : getEnv("VITE_BACKEND_URL") + "/api";
  }
  return config;
});

axios.interceptors.request.use(async (request) => {
  const keycloak: Keycloak = getKeycloakInstance();
  if (!keycloak.didInitialize) {
    request.headers.Authorization = `Bearer ${getCookie("keycloakToken")}`;
  } else {
    await keycloak.updateToken(30);
    request.headers.Authorization = `Bearer ${keycloak.token}`;
  }

  return request;
});

//intercept 401
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      const keycloak: Keycloak = getKeycloakInstance();
      if (keycloak.didInitialize) {
        await keycloak.login();
      } else {
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      window.location.href = "/403";
      console.error(
        "Access forbidden: You do not have permission to access this resource.",
      );
    } else if (error.response?.status === 404) {
      // Handle 404 Not Found error
      console.error(
        "Resource not found: The requested resource could not be found.",
      );
    } else if (error.response?.status === 500) {
      // Handle 500 Internal Server Error
      console.error(
        "Internal server error: An unexpected error occurred on the server.",
      );
    } else {
      // Handle other errors
      console.error("An unexpected error occurred:", error.message);
    }
    return Promise.reject(error);
  },
);

export default axios;
